import _Field from "redux-form/es/Field";
import _InputAdornment from "@material-ui/core/esm/InputAdornment";
import React from 'react';
import { CreditCardSvgIcon } from 'swag-client-common/components/svg/credit-card.svg';
import { LockSvgIcon } from 'swag-client-common/components/svg/lock.svg';
import { CalendarSvgIcon } from 'swag-client-common/components/svg/calendar.svg';
import { FormRow } from '../payment-details/form-row';
import { FormInput } from '../payment-details/form-input';
import responsiveFormClasses from '../payment-details/payment-form-styling/payment-form-styling.scss';
import fixedFormClasses from '../payment-details/payment-form-styling/payment-form-styling-fixed.scss';
import StripeCardNumberElement from '../stripe-element-card-number';
import StripeCardExpiryElement from '../stripe-element-card-expiry';
import StripeCvcElement from '../stripe-element-card-cvc';
import StyledInput from '../payment-details/styled-input';
import classes from './stripe-checkout-form.scss';
export class StripeCheckoutForm extends React.Component {
  render() {
    const {
      disableWholeForm,
      popupType,
      isFixedStyles
    } = this.props;
    const formClasses = isFixedStyles ? fixedFormClasses : responsiveFormClasses;
    return /*#__PURE__*/React.createElement(FormRow, {
      isFixedStyles: isFixedStyles
    }, /*#__PURE__*/React.createElement(FormInput, {
      isFixedStyles: isFixedStyles,
      width: 50
    }, /*#__PURE__*/React.createElement(_Field, {
      component: disableWholeForm ? StyledInput : StripeCardNumberElement,
      className: formClasses.error,
      label: "Card Number",
      placeholder: "Card Number",
      type: "text",
      name: "number",
      disabled: disableWholeForm,
      isFixedStyles: isFixedStyles,
      dataInput: "CardNumber",
      popupType: popupType,
      InputProps: disableWholeForm ? {
        disableUnderline: true,
        startAdornment: /*#__PURE__*/React.createElement(_InputAdornment, {
          className: classes.adornment,
          position: "start"
        }, /*#__PURE__*/React.createElement(CreditCardSvgIcon, null))
      } : null
    })), /*#__PURE__*/React.createElement(FormInput, {
      isFixedStyles: isFixedStyles,
      width: 25
    }, /*#__PURE__*/React.createElement(_Field, {
      component: disableWholeForm ? StyledInput : StripeCardExpiryElement,
      className: formClasses.error,
      label: "Exp date",
      placeholder: "Exp date",
      type: "text",
      name: "expDate",
      disabled: disableWholeForm,
      isFixedStyles: isFixedStyles,
      dataInput: "ExpDate",
      popupType: popupType,
      InputProps: disableWholeForm ? {
        disableUnderline: true,
        startAdornment: /*#__PURE__*/React.createElement(_InputAdornment, {
          className: classes.adornment,
          position: "start"
        }, /*#__PURE__*/React.createElement(CalendarSvgIcon, null))
      } : null
    })), /*#__PURE__*/React.createElement(FormInput, {
      isFixedStyles: isFixedStyles,
      width: 25
    }, /*#__PURE__*/React.createElement(_Field, {
      component: disableWholeForm ? StyledInput : StripeCvcElement,
      className: formClasses.error,
      label: "CVC",
      placeholder: "CVC",
      type: "password",
      name: "cvc",
      disabled: disableWholeForm,
      isFixedStyles: isFixedStyles,
      dataInput: "CVC",
      popupType: popupType,
      InputProps: disableWholeForm ? {
        disableUnderline: true,
        startAdornment: /*#__PURE__*/React.createElement(_InputAdornment, {
          className: classes.adornment,
          position: "start"
        }, /*#__PURE__*/React.createElement(LockSvgIcon, null))
      } : null
    })));
  }
}